export default {
	mainData: {},
	supplies: {
		guidelineModel: {
			hasInformationJobEvaluation: false,
			hasPreviewValues: false,
			verbsSelection: {
				highCommand: {},
				mediumCommand: {},
				lowCommand: {},
			},
			levelSelection: {
				role: {},
				title: {},
				experience: {},
			},
			hierarchyAssignation: [],
			organizationChart: [],
			userForm: {
				jobList: [],
			},
		},
		valuationModel: {
			factorList: [],
			degreesList: [],
			selectedFactors: [],
			weighing: {
				selectedFactor: {},
				combinations: [],
			},
			degree: {
				selectedFactor: {},
				factorDegrees: {},
			},
		},
	},
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/state.js